import React, { useState } from 'react';
export const Spotlight = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    organization: '',
    socialMedia: '',
    bio: '',
    mission: '',
    inspiration: '',
    problem: '',
    impact: '',
    experience: '',
    moment: '',
    collaborations: '',
    influences: '',
    advice: '',
    photoLinks: '',
    logoLink: '',
    consent: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      const form = e.target;
      const formData = new FormData(form);
      // Log form data for debugging (would remove in production)
      console.log('Submitting form to Formspree...');
      const response = await fetch('https://formspree.io/f/mnngozny', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });
      const responseData = await response.json();
      if (response.ok) {
        console.log('Form submitted successfully');
        setIsSubmitted(true);
        form.reset();
      } else {
        console.error('Form submission failed:', responseData);
        setErrorMessage(responseData.error || 'Form submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('Network or server error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="pt-20 min-h-screen" data-id="element-2722">
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-2723">
        <div className="container mx-auto px-4" data-id="element-2724">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2725">
            <h1 className="text-4xl font-bold mb-6 text-gray-800" data-id="element-2726">
              ✨ The Salon Spotlight
            </h1>
            <p className="text-gray-600 mb-4" data-id="element-2727">
              We're shining the light on remarkable people shaping culture in
              their own unique ways — creators, thinkers, innovators, builders,
              and dreamers who are pushing boundaries and making impact.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-2728">
              This feature is part of The Networking Salon's ongoing effort to
              celebrate individuals who are moving ideas, communities, and
              culture forward.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-2729">
              Please fill in the details below to help us tell your story
              beautifully.
            </p>
            <p className="text-gray-600 font-medium" data-id="element-2730">
              Short, honest, and heartfelt responses are best.
            </p>
          </div>
        </div>
      </section>
      <section className="py-12" data-id="element-2731">
        <div className="container mx-auto px-4" data-id="element-2732">
          <div className="max-w-3xl mx-auto" data-id="element-2733">
            {isSubmitted ? <div className="text-center py-16 px-6 border-2 border-gray-300 rounded-lg" data-id="element-2734">
                <h2 className="text-2xl font-bold mb-4 text-gray-800" data-id="element-2735">
                  Thank you for sharing your story with us!
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-2736">
                  Our team will review your submission and reach out when your
                  feature is scheduled.
                </p>
                <p className="text-gray-600 font-medium" data-id="element-2737">
                  Keep creating, building, and shaping the culture — the world
                  needs what you bring. 💫
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-10" data-id="element-2738">
                {errorMessage && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md" data-id="element-2739">
                    <p className="font-medium" data-id="element-2740">Error submitting form:</p>
                    <p data-id="element-2741">{errorMessage}</p>
                  </div>}
                {/* SECTION 1: Personal Details */}
                <div className="space-y-6" data-id="element-2742">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2743">
                    SECTION 1: Personal Details
                  </h2>
                  <div className="space-y-4" data-id="element-2744">
                    <div data-id="element-2745">
                      <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-2746">
                        Full Name *
                      </label>
                      <input type="text" id="fullName" name="fullName" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2747" />
                    </div>
                    <div data-id="element-2748">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-2749">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2750" />
                    </div>
                    <div data-id="element-2751">
                      <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-2752">
                        Phone Number (WhatsApp Preferred) *
                      </label>
                      <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2753" />
                    </div>
                    <div data-id="element-2754">
                      <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-2755">
                        City / Country *
                      </label>
                      <input type="text" id="location" name="location" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2756" />
                    </div>
                    <div data-id="element-2757">
                      <label htmlFor="role" className="block text-gray-700 font-medium mb-1" data-id="element-2758">
                        Role / Profession / Creative Focus *
                      </label>
                      <input type="text" id="role" name="role" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2759" />
                    </div>
                    <div data-id="element-2760">
                      <label htmlFor="organization" className="block text-gray-700 font-medium mb-1" data-id="element-2761">
                        Organization, Brand, or Project Name
                      </label>
                      <input type="text" id="organization" name="organization" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-2762" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2763">Optional</p>
                    </div>
                    <div data-id="element-2764">
                      <label htmlFor="socialMedia" className="block text-gray-700 font-medium mb-1" data-id="element-2765">
                        Social Media Links (Please include any that apply)
                      </label>
                      <textarea id="socialMedia" name="socialMedia" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={5} placeholder="LinkedIn:
Instagram:
X (Twitter):
Website / Portfolio:" onChange={handleChange} data-id="element-2766"></textarea>
                    </div>
                    <div data-id="element-2767">
                      <label htmlFor="bio" className="block text-gray-700 font-medium mb-1" data-id="element-2768">
                        Short Bio (3–5 lines) *
                      </label>
                      <textarea id="bio" name="bio" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2769"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 2: Your Story */}
                <div className="space-y-6" data-id="element-2770">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2771">
                    SECTION 2: Your Story
                  </h2>
                  <div className="space-y-4" data-id="element-2772">
                    <div data-id="element-2773">
                      <label htmlFor="mission" className="block text-gray-700 font-medium mb-1" data-id="element-2774">
                        Tell us about what you do. What's your mission or
                        creative focus? *
                      </label>
                      <textarea id="mission" name="mission" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2775"></textarea>
                    </div>
                    <div data-id="element-2776">
                      <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-2777">
                        What inspired you to start this journey? *
                      </label>
                      <textarea id="inspiration" name="inspiration" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2778"></textarea>
                    </div>
                    <div data-id="element-2779">
                      <label htmlFor="problem" className="block text-gray-700 font-medium mb-1" data-id="element-2780">
                        What problem are you trying to solve — or what change
                        are you hoping to make?
                      </label>
                      <textarea id="problem" name="problem" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2781"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2782">Optional</p>
                    </div>
                  </div>
                </div>
                {/* SECTION 3: Culture & Impact */}
                <div className="space-y-6" data-id="element-2783">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2784">
                    SECTION 3: Culture & Impact
                  </h2>
                  <div className="space-y-4" data-id="element-2785">
                    <div data-id="element-2786">
                      <label htmlFor="impact" className="block text-gray-700 font-medium mb-1" data-id="element-2787">
                        How do you think your work contributes to shaping
                        culture or your community? *
                      </label>
                      <textarea id="impact" name="impact" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2788"></textarea>
                    </div>
                    <div data-id="element-2789">
                      <label htmlFor="experience" className="block text-gray-700 font-medium mb-1" data-id="element-2790">
                        What do you want people to feel or experience through
                        what you do?
                      </label>
                      <textarea id="experience" name="experience" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2791"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2792">Optional</p>
                    </div>
                    <div data-id="element-2793">
                      <label htmlFor="moment" className="block text-gray-700 font-medium mb-1" data-id="element-2794">
                        Share one moment that reminded you your work matters. *
                      </label>
                      <textarea id="moment" name="moment" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2795"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 4: Connection & Inspiration */}
                <div className="space-y-6" data-id="element-2796">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2797">
                    SECTION 4: Connection & Inspiration
                  </h2>
                  <div className="space-y-4" data-id="element-2798">
                    <div data-id="element-2799">
                      <label htmlFor="collaborations" className="block text-gray-700 font-medium mb-1" data-id="element-2800">
                        What kind of collaborations or opportunities are you
                        open to right now?
                      </label>
                      <textarea id="collaborations" name="collaborations" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2801"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2802">Optional</p>
                    </div>
                    <div data-id="element-2803">
                      <label htmlFor="influences" className="block text-gray-700 font-medium mb-1" data-id="element-2804">
                        Who or what influences your work the most? *
                      </label>
                      <textarea id="influences" name="influences" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2805"></textarea>
                    </div>
                    <div data-id="element-2806">
                      <label htmlFor="advice" className="block text-gray-700 font-medium mb-1" data-id="element-2807">
                        What advice would you give to other young people trying
                        to build something meaningful? *
                      </label>
                      <textarea id="advice" name="advice" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-2808"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 5: Visuals */}
                <div className="space-y-6" data-id="element-2809">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2810">
                    SECTION 5: Visuals
                  </h2>
                  <div className="space-y-4" data-id="element-2811">
                    <div data-id="element-2812">
                      <label htmlFor="photoLinks" className="block text-gray-700 font-medium mb-1" data-id="element-2813">
                        Links to 1–2 photos (portrait or action shots) *
                      </label>
                      <textarea id="photoLinks" name="photoLinks" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={3} placeholder="Paste Google Drive, Dropbox, or other image links here. One link per line." onChange={handleChange} data-id="element-2814"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2815">
                        Please provide publicly accessible links to your photos
                        (Google Drive, Dropbox, etc.)
                      </p>
                    </div>
                    <div data-id="element-2816">
                      <label htmlFor="logoLink" className="block text-gray-700 font-medium mb-1" data-id="element-2817">
                        Optional: Link to your logo or brand image
                      </label>
                      <input type="url" id="logoLink" name="logoLink" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" placeholder="https://example.com/your-logo.png" onChange={handleChange} data-id="element-2818" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2819">
                        Optional. Paste a link to your logo or brand image.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Final Consent */}
                <div className="space-y-6" data-id="element-2820">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-2821">
                    Final Consent
                  </h2>
                  <div data-id="element-2822">
                    <p className="block text-gray-700 font-medium mb-2" data-id="element-2823">
                      Do you give The Networking Salon permission to feature
                      your story, photos, and content (with credit) across its
                      digital platforms and media? *
                    </p>
                    <div className="space-y-2" data-id="element-2824">
                      <label className="flex items-center" data-id="element-2825">
                        <input type="radio" name="consent" value="Yes, I do" required className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-2826" />
                        <span className="text-gray-700" data-id="element-2827">Yes, I do</span>
                      </label>
                      <label className="flex items-center" data-id="element-2828">
                        <input type="radio" name="consent" value="I'd like to review my feature before it's published (T&C Apply)" className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-2829" />
                        <span className="text-gray-700" data-id="element-2830">
                          I'd like to review my feature before it's published
                          (T&C Apply)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* Submit Button */}
                <div className="pt-4" data-id="element-2831">
                  <button type="submit" disabled={isSubmitting} className="w-full py-3 px-6 bg-gray-800 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 disabled:opacity-70" data-id="element-2832">
                    {isSubmitting ? 'Submitting...' : 'Submit Your Story'}
                  </button>
                </div>
              </form>}
          </div>
        </div>
      </section>
    </div>;
};